import React from 'react';

import * as S from './styles';

const Gallery04: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Photo1
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="200ms"
        />
        <S.Caption className="mobile">
          <p>
            Looks esportivos listrados da Household Brigade, grupo de militares
            britânicos durante a Primeira Guerra Mundial, nos anos 1910 | Foto:
            reprodução do livro “100 anos de moda masculina”.
          </p>
        </S.Caption>
        <S.Photo2
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="400ms"
        />
        <S.Caption className="mobile">
          <p>
            Look do verão 2023 de Thom Browne resgata padrão de vestimenta
            esportivo escocês do início do século 20. | Foto: Getty Images
          </p>
        </S.Caption>
      </S.Wrapper>
      <S.Caption className="desktop">
        <p>
          À esq., look do verão 2023 de Thom Browne resgata padrão de vestimenta
          esportivo escocês do início do século 20 (à esq.); à dir., reprodução
          da revista masculina Taylor & Cutter, dos anos 1910. Getty Images e
          reprodução do livro “100 anos de moda masculina”.
        </p>
      </S.Caption>
    </S.Container>
  );
};

export default Gallery04;
